import {useFilterProviders} from '@github-ui/shared-filter-providers/providers/use-filter-providers'

interface UseSavedViewFilterProvidersOptions {
  owner: string
  repo: string
}

export function useSavedViewFilterProviders({owner, repo}: UseSavedViewFilterProvidersOptions) {
  return useFilterProviders({
    repositoryScope: owner && repo ? `${owner}/${repo}` : undefined,
    isOrgScope: true,
    isIssueFieldsEnabled: true,
  })
}
